export const linkToMergeFields = [
    {
        name: 'url',
        label: 'Activation URL',
        value: 'url',
        useAdditionalInput: false,
        format: () => '{url}',
    },
    {
        name: 'consent',
        label: 'Consent',
        value: 'consent',
        useAdditionalInput: false,
        format: () => '{consent}',
    },
    {
        name: 'consent tracking allow',
        label: 'Consent tracking allow',
        value: 'consenttrackingallow',
        useAdditionalInput: false,
        format: () => '{consenttrackingallow}',
    },
    {
        name: 'consent tracking deny',
        label: 'Consent tracking deny',
        value: 'consenttrackingdeny',
        useAdditionalInput: false,
        format: () => '{consenttrackingdeny}',
    },
    {
        name: 'contact profile',
        label: 'Contact profile',
        value: 'contactprofile',
        useAdditionalInput: false,
        format: () => '{contactprofile}',
    },
    {
        name: 'custom',
        label: 'Custom',
        value: 'custom',
        useAdditionalInput: true,
        format: (additionalInputValue: string) =>
            `${!additionalInputValue?.startsWith('{') ? '{' : ''}${additionalInputValue ?? ''}${
                !additionalInputValue?.endsWith('}') ? '}' : ''
            }`,
    },
    {
        name: 'unsubscribe',
        label:  'Unsubscribe',
        value: 'unsubscribe',
        useAdditionalInput: false,
        format: () => '{unsubscribe}',
    },
    {
        name: 'unsubscribe list',
        label: 'Unsubscribe list (mailing preferences)',
        value: 'unsubscribelist',
        useAdditionalInput: false,
        format: () => '{unsubscribelist}',
    },
    {
        name: 'unsubscribe from list',
        label: 'Unsubscribe from list',
        value: 'unsubscribefromlist',
        useAdditionalInput: false,
        format: () => '{unsubscribefromlist}',
    },
    {
        name: 'view online',
        label:  'View online',
        value: 'view',
        useAdditionalInput: false,
        format: () => '{view}',
    }
];

export const TAG_STYLES = new Map([
    ['strong', { style: 'font-weight: bold;', className: 'bold' }],
    ['u', { style: 'display: inline-block; text-decoration: underline;', className: 'underline' }],
    ['em', { style: 'font-style: italic;', className: 'italic' }],
]);
